// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminDashboard_container__T0XSb","box":"AdminDashboard_box__2yWxZ","sideBar":"AdminDashboard_sideBar__A_YHF","calendar":"AdminDashboard_calendar__3lME4"};